module.exports = __webpack_public_path__ + "img/avatar-3.2de408d3.png";